/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PhoneNumberType {
    DEFAULT = 'Default',
    MOBILE = 'Mobile',
    HOME = 'Home',
    BUSINESS = 'Business',
}
